import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { FeedbackService } from '../manik-library/FeedbackService';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Title } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
declare var $: any;

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css'],
})
export class FeedbackComponent implements OnInit {
  Response: any;
  Citizen: Object;
  fatch: Object;
  FeedbackForm!: FormGroup;
  image: any;

  constructor(
    private _feedbackService: FeedbackService,
    public _routeParams: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private titleService: Title,
    private formBuilder: FormBuilder
  ) {
    this.titleService.setTitle('Feedback');
  }
  @ViewChild('otpModalButton') otpModalButton: any | undefined;
  @ViewChild('loginModalClose') loginModalClose: any | undefined;
  @ViewChild('nameModalClose') nameModalClose: any | undefined;
  @ViewChild('openloginname') openloginname: any | undefined;
  @ViewChild('otpModalClose') otpModalClose: any | undefined;
  @ViewChild('myloginModal') myloginModal: any | undefined;

  checkboxList: any = [];
  staffList: any = [];
  companyData: any = {};
  headers: any;
  rating: any = '0.0';
  comments: any = '';
  files: any;
  filesStoredUrl: any = [];
  loginData: any;
  errorMessage = '';
  EmailID: any = '';
  MobileNumber: any = '';
  loginResponse: any = '';
  otpVerifyResponse: any = '';
  EnteredOTP: any = '';
  CitizenName: any = '';
  userData: any;
  data: any;
  header: any;
  CitizenHandle: any;
  isLoggedInVar = false;
  feedbackSubmit = false;
  selectedStaffId: number = 0;
  otpSent: boolean = false;
  secondsToDelay: number = 0;
  sendingOtp: boolean = false;
  loading: boolean = true;

  ngOnInit(): void {
    this.FeedbackForm = this.formBuilder.group({
      Email: new FormControl('', [
        Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
      ]),
      Name: new FormControl('', [Validators.required]),
      Phone: new FormControl(''),
    });

    console.log(this.FeedbackForm);

    const headers = new HttpHeaders({
      TenantID: 'INSTA.WEB',
    });

    this._feedbackService.getToken(headers).subscribe((data) => {
      let Authorization = data['ManikJSon'][0]['JSon0'];
      sessionStorage.setItem('sToken', Authorization);
      this.getFormData();
    });
  }

  onSubmit() {
    console.log('this.filesStoredUrl', this.FeedbackForm);
    if (this.FeedbackForm.invalid) {
      this.FeedbackForm.markAllAsTouched();
      return;
    }
    this.loading = true;
    if (this.isLoggedInVar) {
      let slug: string = this._routeParams.snapshot.params['businessslug'];
      let obj: any = {
        items: [
          {
            StarRating: parseInt(this.rating),
            BusinessHandle: slug,
            ECommBranchID: '',
            CitizenHandle: this.userData.CitizenHandle,
            SelectedParams: [],
            SelectedParamNames: [],
            Review: this.comments,

            ReviewerEmailID: this.FeedbackForm.controls['Email'].value,
            ReviewerName: this.FeedbackForm.controls['Name'].value,
            ReviewerMobile: this.FeedbackForm.controls['Phone'].value,
            StaffID: this.selectedStaffId,
          },
        ],
      };
      this.checkboxList.forEach((element: any) => {
        if (element.checked) {
          obj['items'][0]['SelectedParams'].push(element.RatingParamID);
          obj['items'][0]['SelectedParamNames'].push(element.RatingParameter);
        }
      });
      obj['items'][0]['SelectedParams'] =
        obj['items'][0]['SelectedParams'].join(',');
      obj['items'][0]['SelectedParamNames'] =
        obj['items'][0]['SelectedParamNames'].join(',');
      let config = {
        headers: {
          Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
          'Content-Type': 'application/json',
          Context: 'SUBMIT.REVIEW',
          PortalDS: this.companyData['PortalDS'],
        },
      };
      this._feedbackService.addProfile(obj, config).then((res) => {
        try {
          this.loading = false;
          if (this.filesStoredUrl.length) {
            let ReviewID = JSON.parse(res['data']['STATUS'])['ManikJSon'][0][
              'JSon0'
            ][0]['NewEntity'];
            let obj: any = {
              items: [],
            };
            this.filesStoredUrl.forEach((p) => {
              obj['items'].push({
                ReviewID: ReviewID,
                MediaType: 'I',
                MediaURL: p,
              });
            });
            let config = {
              headers: {
                Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
                'Content-Type': 'application/json',
                Context: 'SUBMIT.REVIEW.MEDIA',
                PortalDS: this.companyData['PortalDS'],
              },
            };
            this._feedbackService.addProfile(obj, config).then((res) => {
              this.feedbackSubmit = true;
            });
          } else {
            this.feedbackSubmit = true;
          }
        } catch (e) {
          this.feedbackSubmit = true;
        }
      }).finally(()=>{
        if(this.feedbackSubmit){
          setTimeout(() => {
            this.feedbackSubmit=false;
            this.comments='';
            this.FeedbackForm.reset();
         
          }, 3000);
        }
      })
    } else {
      this.EmailID = this.FeedbackForm.value['Email'];
      this.MobileNumber = this.FeedbackForm.value['Phone'];
      if (this.EmailID || this.MobileNumber) {
        this.getOtpMobile(true);
      } else {
        this.myloginModal.nativeElement.click();
      }
    }
  

  }

  onRemovePhoto = (i) => {
    this.files = this.files.filter((f, ind) => {
      if (ind != i) {
        return f;
      }
    });
  };

  removeImage() {
    this.image = '';
  }
  getUrlFromFile(file) {
    return this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file));
  }

  sanitizeImageUrl(imageUrl: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(imageUrl);
  }

  previewImages = async (event) => {
    this.files = event.target.files;
    let htmlTemp = '';
    // document.getElementById('image_preview').innerHTML;
    // for (var i = 0; i < this.files.length; i++) {
    //   htmlTemp =
    //     htmlTemp +
    //     '<div class="col-md-3 mt-3 img-preview">' +
    //     '<div class="card border-0">' +
    //     '<img class="card-img" src="' +
    //     URL.createObjectURL(this.files[i]) +
    //     '" alt="Card image">' +
    //     '<div class="card-img-overlay image-cross-icon p-0">' +
    //     '<button type="button" class="close" aria-label="Close">' +
    //     `<span aria-hidden="true"><img (click)="onRemovePhoto(1)" src="../../../assets/images/cancel.svg" class="img-fluid"></span>` +
    //     '</button>' +
    //     '</div>' +
    //     '</div>' +
    //     '</div>';
    // }
    this.image = this.getUrlFromFile(event.target.files[0]);
    console.log(this.image);

    // document.getElementById('image_preview').innerHTML = htmlTemp;

    for (var i = 0; i < this.files.length; i++) {
      let pr = await this.uploadImageNew(this.files[i]);
      this.filesStoredUrl.push(pr);
    }
  };

  uploadImageNew = (file) => {
    return new Promise((res, rej) => {
      var formdata = new FormData();
      formdata.append(file.name, file);
      let config = {
        headers: {
          FolderPath: 'http://resources.manikworks.com/',
          'Content-Type': 'application/x-www-form-urlencoded',
          FileName: file.name,
        },
      };
      this._feedbackService
        .uploadImage('https://imagehandler.manikworks.com', formdata, config)
        .then((data) => {
          res(data.data['ManikJSon'][0]['JSon0'][0]['DocURL']);
        });
    });
  };

  toggleCheckbox(i) {
    this.checkboxList[i].checked != this.checkboxList[i].checked;
  }

  getFormData() {
    let slug: string = this._routeParams.snapshot.params['businessslug'];
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
      Operation: 'FETCH.FEEDBACK.JSON',
      BusinessHandle: slug,
      'Content-Type': 'application/json',
    });
    this._feedbackService.getFeebackFormData(headers).subscribe((data) => {
      if (
        data['ManikJSon'][0]['JSon2'] &&
        data['ManikJSon'][0]['JSon2'].length &&
        data['ManikJSon'][0]['JSon2'][0].RatingParamID
      ) {
        this.checkboxList = data['ManikJSon'][0]['JSon2']?.map((i) => {
          i.checked = false;
          return i;
        });
      }
      this.companyData = data['ManikJSon'][0]['JSon0'][0];
      this.staffList = data['ManikJSon'][0]['JSon1'];
      this.loginData = data['ManikJSon'][0]['JSon3'][0];
      this.FeedbackForm.controls['Phone'].setValidators([
        Validators.minLength(this.loginData['MobileNumberLength']),
        Validators.maxLength(this.loginData['MobileNumberLength']),
      ]);
      if (this.loginData['SMSActivated'] == 'Y') {
        this.FeedbackForm.controls['Phone'].setValidators([
          Validators.required,
          Validators.minLength(this.loginData['MobileNumberLength']),
          Validators.maxLength(this.loginData['MobileNumberLength']),
        ]);
      } else {
        this.FeedbackForm.controls['Email'].setValidators([
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ]);
      }
      this.FeedbackForm.controls['Email'].updateValueAndValidity();
      this.FeedbackForm.controls['Phone'].updateValueAndValidity();
      this.loading = false;
    });
  }

  //login
  getOtpMobile(isNew) {
    console.log("this.companyData['PortalDS']", this.companyData['PortalDS']);

    this.sendingOtp = true;
    this.errorMessage = '';
    if (this.loginData['SMSActivated'] === 'Y') {
      if (
        !this.MobileNumber ||
        String(this.MobileNumber).length != this.loginData['MobileNumberLength']
      ) {
        console.log(
          this.MobileNumber.length,
          this.loginData['MobileNumberLength']
        );
        return (this.errorMessage = 'Enter a valid Phone number');
      }
      let data = {
        items: [
          {
            CountryCode: this.loginData['CountryCode'],
            MobileNumber: this.MobileNumber,
            LanguageID: '100000',
            CountryID: JSON.stringify(this.loginData['CountryID']),
          },
        ],
      };
      const headers = new HttpHeaders({
        Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
        Operation: 'LOGIN.BY.MOBILE',
        'Content-Type': 'application/json',
        AuthChannel: 'M',
        SignUpSource: 'A',
        PortalContext: this.companyData['PortalDS'],
        Encryption: 'noitpyrcne',
        RecoverPassword: 'Y',
        Format: 'N',
      });
      this._feedbackService.loginViaMobile(data, headers).subscribe(
        (data) => {
          this.loading = false;
          if (isNew) {
            this.loginModalClose.nativeElement.click();
            this.otpModalButton.nativeElement.click();
          }
          this.loginResponse = data['payload'];
          this.startTimer();
        },
        (error) => {
          this.sendingOtp = false;
        }
      );
    } else if (this.loginData['SMSActivated'] === 'N') {
      if (!this.EmailID) return (this.errorMessage = 'Enter a valid Email id');
      let data = {
        items: [
          {
            EmailID: this.EmailID,
            LanguageID: '100000',
            CountryID: JSON.stringify(this.loginData['CountryID']),
          },
        ],
      };
      const headers = new HttpHeaders({
        Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
        Operation: 'LOGIN.BY.EMAIL',
        'Content-Type': 'application/json',
        AuthChannel: 'E',
        SignUpSource: 'A',
        PortalContext: this.companyData['PortalDS'],
        Encryption: 'noitpyrcne',
        RecoverPassword: 'Y',
        Format: 'N',
      });
      this._feedbackService.loginViaEmail(data, headers).subscribe(
        (data) => {
          if (isNew) {
            this.loginModalClose.nativeElement.click();
            this.otpModalButton.nativeElement.click();
          }
          this.loginResponse = data['payload'];
          this.startTimer();
        },
        (error) => {
          this.sendingOtp = false;
        }
      );
    }
  }

  startTimer() {
    this.sendingOtp = false;
    this.otpSent = true;
    this.secondsToDelay = 30;
    const interval = setInterval(() => {
      this.secondsToDelay--;
      if (this.secondsToDelay === 0) {
        this.otpSent = false;
        clearInterval(interval);
      }
    }, 1000);
  }

  verifyOtp() {
    console.log(this.EnteredOTP);

    this.CitizenName = this.FeedbackForm.value['Name'];
    this.errorMessage = '';
    if (!this.EnteredOTP) return (this.errorMessage = 'Fill OTP');
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
      Operation: 'VERIFY.OTP',
      OTPHandle: this.loginResponse['J'][0]['OTPHandle'],
      EnteredOTP: `${this.EnteredOTP}`,
      'Content-Type': 'application/json',
      PortalContext: this.companyData['PortalDS'],
      Encryption: 'noitpyrcne',
      Format: 'N',
    });
    this._feedbackService.verifyOtp(headers).subscribe(
      (data) => {
        this.otpVerifyResponse = data['payload'][1][0];
        this.CitizenHandle = data['payload'][1][0].CitizenHandle;
        if (data['payload'][2][0]['Name'] === 'INCOMPLETE') {
          this.CitizenName = this.FeedbackForm.value['Name'];
          this.otpModalClose.nativeElement.click();
          this.openloginname.nativeElement.click();
        } else {
          this.otpModalClose.nativeElement.click();
          this.getProfile(this.CitizenHandle);
        }
        this.isLoggedInVar = true;
      },
      (error) => {
        this.errorMessage = 'Invalid OTP';
      }
    );
  }

  getProfile(CitizenHandle) {
    let obj = {
      items: [{ CitizenHandle: CitizenHandle }],
    };
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
      Operation: 'GET.PROFILE',
      'Content-Type': 'application/json',
      PortalContext: this.companyData['PortalDS'],
      Encryption: 'noitpyrcne',
      Format: 'N',
    });
    this._feedbackService.getProfile(obj, headers).subscribe((data) => {
      this.userData = data['payload']['J'][0];

      this.onSubmit();
    });
  }

  OnSaveName() {
    let data = {
      items: [
        {
          CitizenName: this.CitizenName,
          CitizenHandle: this.CitizenHandle,
        },
      ],
    };
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
      Operation: 'UPDATE.NAME',
      'Content-Type': 'application/json',
      PortalContext: this.companyData['PortalDS'],
      Encryption: 'noitpyrcne',
      Format: 'N',
    });
    try {
      this._feedbackService.isLoggedIn(data, headers).subscribe((data) => {
        this.nameModalClose.nativeElement.click();
        this.getProfile(this.CitizenHandle);
      });
    } catch (e) {
      console.log(e);
    }
  }
  deleteMe(id: number) {
    this.staffList.map((x) => (x.isSelected = false));
    this.staffList.find((x) => x.MemberID === id).isSelected = true;
    this.selectedStaffId = id;
  }

  onStarClick() {
    const sim = $("input[type='radio']:checked").val();
    this.rating = sim;
    if (sim < 3) {
      $('.myratings').css('color', 'red');
      $('.myratings').text(sim);
    } else {
      if (sim == 5) {
        $('.myratings').css('color', '#3A1593');
        $('.myratings').text('Excellent', sim);
      }
      $('.myratings').css('color', '#3A1593');
      $('.myratings').text(sim);
    }
  }
  
}
